<!--考试-->
<template>
    <div class="el-Examination">
        <el-row class="page_content">
            <h1 class="head_title_white">
              <el-row>
                <el-col :span="12" :title="examName">
                  <span class="limit_line_one">{{examName}} - 查看答卷</span>
                </el-col>
                <el-col :span="12">
                  <!-- <span class="djs">考试剩余时间：120 分钟 0 秒</span> -->
                  <el-button type="primary" style="float: right;" @click="$closeWin()">关 闭</el-button>
                </el-col>
              </el-row>

            </h1>
            <div class="bg_"></div>
            <el-row>
                <el-container>
                    <el-aside width="380px">

                        <fieldset class="stuInfo">
                            <legend>考生信息</legend>
                            <el-row>
                              <el-col :span="12">
                                <img :src="rzImg" style="width:100px;height:100px;" />

                              </el-col>
                              <el-col :span="12">
                                <p>姓名：{{studentInfo.studentName}}</p>
                                <p>
                                  学号：{{studentInfo.studentNo}}
                                </p>

                              </el-col>
                            </el-row>
                            <el-row style="line-height: 40px;">
                              <template v-if="!$isEmpty(fractionText) || !$isEmpty(fractionText)">
                                <el-col :span="24">总分：<label class="fraction">{{fractionText || fraction}}</label></el-col>
                              </template>
                              <template v-if="$isEmpty(fractionText) && $isEmpty(fractionText)">
                                <el-col :span="12">客观题数量：<a class="fraction">{{choiceNum}}</a></el-col>
                                <el-col :span="12">主观题数量：<label class="fraction">{{noChoiceNum}}</label></el-col>
                                <el-col :span="12">客观题得分：<label class="fraction">{{choiceScoreStr}}</label></el-col>
                                <el-col :span="12">主观题得分：<label class="fraction">{{noChoiceNumStr || '未改卷'}}</label></el-col>
                              </template>
                            </el-row>
                        </fieldset>
                        <el-row class="dtk_all">
                            <el-row style="background-color: rgb(227 234 246);padding: 10px;margin-bottom:10px;">
                                <span style="color:#409EFF;margin-right:10px;font-weight: 700;">答题卡</span>
                                <span style="color:#e6a23c;">{{numberTopics}} | {{examInfo.length}}</span>
                                <span style="float:right;">
                                    <span style="background-color: red;padding: 3px 12px;margin-right:10px;"></span>错误
                                    <span style="background-color: #d1e43c;padding: 3px 12px;margin-right:10px;"></span>未判
                                    <span style="background-color: #67c23a;padding: 3px 12px;margin-right:10px;"></span>正确
                                </span>
                            </el-row>
                            <template v-for='(item,index) in questionMap'>
                              <el-row class="dtk_h" :key="'title'+index">
                                {{index}}
                              </el-row>
                              <el-row style="padding: 10px;">
                                  <ul>
                                    <template v-for='(it,ind) in item.list'>
                                      <li :class="answerOrNot(it)" :key="it.examQuestionId+'_left'" @click="jump(it.examQuestionId)">
                                      {{Number(item.num) - Number(item.list.length) + ind + 1}}
                                      </li>
                                    </template>
                                  </ul>
                              </el-row>
                            </template>
                        </el-row>
                    </el-aside>
                  <el-main>
                  <el-row class="all_subject">
                    <template v-for='(item,index) in examInfo'>
                      <template v-if="index == 0 || (examInfo[index  - 1].examQuestionTypeName != examInfo[index].examQuestionTypeName)">
                        <h1>{{item.examQuestionTypeName}}</h1>
                      </template>
                      <template v-if="item.examQuestionTypeConcat == 1">
                        <el-row :key="index" :class="'jump'+item.examQuestionId">
                            <p class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.examQuestionStem)"></el-row>
                            </p>
                            <el-row>
                                <el-col :span="24">
                                    <ul>
                                        <el-radio-group v-model="radio[item.examQuestionId]" @change="radioChange(item.examQuestionId)">
                                            <li v-for="(it,inde) in item.examQuestionOptionList">
                                              <el-radio disabled :label="it.examQuestionOptionOptionSign">
                                                <el-row style="float: left;" v-html="it.examQuestionOptionOptionSign +'、'"></el-row>
                                                <el-row style="float: left;" v-html="$imgHtml(it.examQuestionOptionOptionContent)"></el-row>
                                              </el-radio>
                                            </li>
                                        </el-radio-group>
                                    </ul>
                                </el-col>
                            </el-row>
                            <el-row class="seeStudentAnswer">
                              <template v-if="item.isWrong == 2">
                                <i class="el-icon-success" style="font-size: 50px;color: rgb(64, 158, 255);float: left;"></i>
                              </template>
                              <template v-else>
                                <i class="el-icon-error" style="font-size: 50px;color: red;float: left;"></i>
                              </template>
                              <p class="answer" v-if="examContinueCheckAnswer == 1">参考答案：{{item.examQuestionAnswer}}</p>
                            </el-row>
                        </el-row>
                      </template>

                      <template v-if="item.examQuestionTypeConcat == 2">
                        <el-row :key="index" :class="'jump'+item.examQuestionId">
                            <p class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.examQuestionStem)"></el-row>
                            </p>
                            <el-row>
                                <el-col :span="24">
                                    <ul>
                                        <el-checkbox-group v-model="checkbox[item.examQuestionId]" @change="checkboxChange(item.examQuestionId)">
                                            <li v-for="(it,inde) in item.examQuestionOptionList">
                                              <el-checkbox disabled :label="it.examQuestionOptionOptionSign">
                                                <el-row style="float: left;" v-html="it.examQuestionOptionOptionSign +'、'"></el-row>
                                                <el-row style="float: left;" v-html="$imgHtml(it.examQuestionOptionOptionContent)"></el-row>
                                              </el-checkbox>
                                            </li>
                                        </el-checkbox-group>
                                    </ul>
                                </el-col>
                            </el-row>
                            <el-row class="seeStudentAnswer">
                              <template v-if="item.isWrong == 2">
                                <i class="el-icon-success" style="font-size: 50px;color: rgb(64, 158, 255);float: left;"></i>
                              </template>
                              <template v-else>
                                <i class="el-icon-error" style="font-size: 50px;color: red;float: left;"></i>
                              </template>
                              <p class="answer" v-if="examContinueCheckAnswer == 1">参考答案：{{item.examQuestionAnswer}}</p>
                            </el-row>
                        </el-row>
                      </template>

                      <template v-if="item.examQuestionTypeConcat == 3">
                        <el-row :key="index" :class="'jump'+item.examQuestionId">
                            <p class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.examQuestionStem)"></el-row>
                            </p>
                            <el-row>
                                <el-col :span="24">
                                    <ul>
                                        <el-radio-group disabled v-model="judgeQuestion[item.examQuestionId]" @change="judgeQuestionChange(item.examQuestionId)">
                                            <li><el-radio label="对">对</el-radio></li>
                                            <li><el-radio label="错">错</el-radio></li>
                                        </el-radio-group>
                                    </ul>
                                </el-col>
                            </el-row>
                            <el-row class="seeStudentAnswer">
                              <template v-if="item.isWrong == 2">
                                <i class="el-icon-success" style="font-size: 50px;color: rgb(64, 158, 255);float: left;"></i>
                              </template>
                              <template v-else>
                                <i class="el-icon-error" style="font-size: 50px;color: red;float: left;"></i>
                              </template>
                              <p class="answer" v-if="examContinueCheckAnswer == 1">参考答案：{{item.examQuestionAnswer}}</p>
                            </el-row>
                        </el-row>
                      </template>

                      <template v-if="item.examQuestionTypeConcat == 4">
                          <el-row :key="index" :class="'jump'+item.examQuestionId">
                              <p class="stem">
                                <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                                <el-row style="float:left;" v-html="$imgHtml(item.examQuestionStem)"></el-row>
                              </p>
                              <el-row>
                                  <el-col :span="24">
                                      <el-input disabled  :rows="3" type="textarea" style="margin:10px 0;" v-model="shortAnswer[item.examQuestionId]"></el-input>
                                  </el-col>
                              </el-row>
                              <template v-if="item.studentAnswerImgs != null && item.studentAnswerImgs != ''">
                                <el-image
                                    v-for="(itImg,index) in item.imgList"
                                    :key="item.examQuestionId+index+'imgList'"
                                    style="width: 120px; height: 120px;margin: 0 10px 5px 0;border: 1px dashed #dddddd;"
                                    :src="itImg"
                                    :preview-src-list="item.imgList">
                                </el-image>
                              </template>
                          </el-row>
                          <el-row class="seeStudentAnswer">
                            <template v-if="$isEmpty(item.studentScore)">
                              <i class="el-icon-question" style="font-size: 50px;color: #d1e43c;float: left;"></i>
                              <p class="answer" style="color: #d1e43c;">未判卷</p>
                            </template>
                            <template v-else>
                              <template v-if="!$isEmpty(item.studentAnswer) && item.studentScore > 0">
                                <i class="el-icon-success" style="font-size: 50px;color: rgb(64, 158, 255);float: left;"></i>
                              </template>
                              <template v-else>
                                <i class="el-icon-error" style="font-size: 50px;color: red;float: left;"></i>
                              </template>
                              <p class="answer" v-if="examContinueCheckAnswer == 1">参考答案：{{item.examQuestionAnswer}}</p>
                            </template>
                          </el-row>
                      </template>
                      <el-row v-if="!$isEmpty(item.examQuestionAnalysis)" style="color: #b4b4b4;line-height: 25px;margin-bottom: 20px;border: 1px solid rgb(204 204 204);padding: 10px 20px;border-radius: 5px;min-height: 80px;">
                          答案解析：<br/>
                          <div style="text-indent: 2em;" v-html="item.examQuestionAnalysis || ''"></div>
                      </el-row>
                    </template>
                </el-row>
                </el-main>
            </el-container>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import rzImg from '@/images/user/rz.png';
import $ from 'jquery';
import {getStorageKeyForRoleTag, getStudentInfoKeyForRoleTag} from "../../../common/ulit";
export default {
  data() {
    return {
      leftNum:0,
      numberTopics:0,
      studentInfo:JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())),
      examStudentId:this.$route.query.examStudentId,
      examName:localStorage.getItem(getStorageKeyForRoleTag('examName_examination')),
      examInfo:[],
      examStudentInfoList:[],
      radio:{}, //单选题答案
      checkbox:{},//多选题答案
      judgeQuestion:{},//判断题
      shortAnswer:{},//简答题
      questionMap:{},//所有题目map("题目类型：{list:[],mum")
      rzImg:rzImg,
      timer:'',
      choiceNum:"", //客观题数量
      noChoiceNum:"", //主观题数量
      noChoiceJudgeNum:"", //主观题数量教师的批改数量
      fraction:"", //总得分
      fractionText:"", //总得分
      choiceScoreStr:"", //客观题得分
      noChoiceNumStr:"", //主观题得分
      examContinueCheckAnswer:2 //允许查看正确答案(1是 2否)
    };
  },
  created() {
      console.log(this.$route.query.examStudentId)
   if(this.$isEmpty(this.examStudentId)){
     this.$message({
        message: "课程数据丢失，请返回上一页！",
        type: 'warning'
     });
   }else{
     this.getExamStudentInfo();
   }
  },
  methods: {
    handleLoad () { //用于重载人脸识别组件
      this.timer = new Date().getTime()
    },
    radioChange(examQuestionId){ //单选题选择
      let param = {
        examQuestionId:examQuestionId,
        studentAnswer:this.radio[examQuestionId]
      }
      this.answerExam({examQuestionJsonStr:JSON.stringify(param)});
    },
    checkboxChange(examQuestionId){ //多选题选择
      let param = {
        examQuestionId:examQuestionId,
        studentAnswer:this.checkbox[examQuestionId].join(",")
      }
      this.answerExam({examQuestionJsonStr:JSON.stringify(param)});
    },
    judgeQuestionChange(examQuestionId){ //判断题
      let param = {
        examQuestionId:examQuestionId,
        studentAnswer:this.judgeQuestion[examQuestionId]
      }
      this.answerExam({examQuestionJsonStr:JSON.stringify(param)});
    },
    shortAnswerBlur(examQuestionId){ //简答题
      let param = {
        examQuestionId:examQuestionId,
        studentAnswer:this.shortAnswer[examQuestionId]
      }
      this.answerExam({examQuestionJsonStr:JSON.stringify(param)});
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getExamStudentInfo(){ //获取考试信息
      const loading = this.$loading({
        lock: true,
        text: '加载试题中请稍后......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$store.dispatch("user/getExamStudentInfo",{examStudentId:this.examStudentId}).then((ret) => {
        loading.close();
        if (ret.code === 0 || ret.code === '0') {
          if(!this.$isEmpty(ret.data.ExamQuestionList)){
            this.examContinueCheckAnswer = ret.data.examContinueCheckAnswer; ////允许查看正确答案(1是 2否)
            let num = 0;
            ret.data.ExamQuestionList.forEach((element,i) => {
              if(element.examQuestionTypeConcat == 1){
                this.radio[element.examQuestionId] = element.studentAnswer;
              }else if(element.examQuestionTypeConcat == 2){
                if(!this.$isEmpty(element.studentAnswer)){
                  this.checkbox[element.examQuestionId] = element.studentAnswer.split(",");
                }else{
                  this.checkbox[element.examQuestionId] = [];
                }
              }else if(element.examQuestionTypeConcat == 3){
                this.judgeQuestion[element.examQuestionId] = element.studentAnswer;
              }else if(element.examQuestionTypeConcat == 4){
                  if(element.studentAnswerImgs != null && element.studentAnswerImgs != ""){
                      let imgList = JSON.parse(element.studentAnswerImgs);
                      element.imgList = [];
                      for(let indx in imgList){
                          element.imgList.push(this.$baseUrl + imgList[indx]);
                      }
                  }
                this.shortAnswer[element.examQuestionId] = element.studentAnswer;
              }

              if(this.$isEmpty(this.questionMap[element.examQuestionTypeName])){
                this.questionMap[element.examQuestionTypeName] = {
                  list:[],
                  num:0
                };
              }
              num = num + 1;
              this.questionMap[element.examQuestionTypeName].list.push(element);
              this.questionMap[element.examQuestionTypeName].num = num;
            });
            this.radio = Object.assign({},this.radio);
            this.checkbox = Object.assign({},this.checkbox);
            this.judgeQuestion = Object.assign({},this.judgeQuestion);
            this.shortAnswer = Object.assign({},this.shortAnswer);

            this.examInfo = ret.data.ExamQuestionList;
            this.examStudentInfoList = ret.data.examStudentInfoList;
            this.examStudentId = ret.data.examStudentId;
            this.choiceNum = ret.data.choiceNum; //客观题数量
            this.noChoiceNum = ret.data.noChoiceNum; //主观题数量
            this.noChoiceJudgeNum = ret.data.noChoiceJudgeNum; //主观题数量教师的批改数量
            this.fraction = ret.data.fraction; //总得分
            this.fractionText = ret.data.fractionText; //总得分
            this.choiceScoreStr = ret.data.choiceScoreStr; //客观题得分
            this.noChoiceNumStr = ret.data.noChoiceNumStr; //主观题得分
          }else{
            this.$message({
               message: "题目数量为空！",
               type: 'warning',
               onClose:()=>{
               this.$closeWin();
               }
            });
          }
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning',
             onClose:()=>{
             　this.$closeWin();
             }
          });
        }
      }).catch(() => {
        loading.close();
      });
    },
    answerExam(param){ //答题
      this.$store.dispatch("user/answerExam",param).then((ret) => {
        if (ret.code != 0 && ret.code != '0') {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      });
    },
    jump (index) {
      let total = $(".jump"+index).position().top;
      let top = $(".all_subject").scrollTop(); //当前滚动条的高度
      $(".all_subject").animate({scrollTop:top + total},1000);//1000是ms,也可以用slow代替

   },
   answerOrNot(obj){ //是否答题
    // if(this.examContinueCheckAnswer == 2){
    //   return "wpj";
    // }
    this.numberTop();
    if(obj.examQuestionTypeConcat == 1 || obj.examQuestionTypeConcat == 2 || obj.examQuestionTypeConcat == 3){
      if(obj.isWrong == 2){
        return "yd";
      }
      return "cw";
    }else if(obj.examQuestionTypeConcat == 4){
      if(!this.$isEmpty(obj.studentScore)){
        if(!this.$isEmpty(obj.studentAnswer) && obj.studentScore > 0){
          return "yd";
        }
        return "cw";
      }else{
        return "wpj";
      }
    }
   },
   numberTop(){
     let this_ = this;
     setTimeout(function(){
       this_.numberTopics = $(".yd").length;
     },100);
   }
  }
};
</script>
<style  lang="less">
  @import '../../../styles/base.less';
  .el-Examination{
    .seeStudentAnswer{
      margin-bottom: 10px;
    }
    .answer{ //参考答案
      line-height: 49px;margin-left: 30px !important;float: left;color: rgb(64, 158, 255);
    }
    .fraction{
      color: rgb(230, 162, 60);
    }
    .head_title_white{
        color: #000000;
        margin-bottom:0;
        .djs{
            float: right;
            min-width: 260px;
            font-weight: 100;
            font-size: 17px;
            line-height: 40px;
            margin-left: 10px;
        }
    }
    .head_title{
        margin: 0;
        font-size: 20px;
        margin-right:-20px;
    }
    .bg_{
        background-color: white;
        margin: 0 -20px;
        border-bottom: 1px solid #f3f3f3;
        margin-bottom: 10px;
    }
    .yd{
      background-color: #67c23a;color: #FFFFFF;
    }
    .cw{
      background-color: red;color: #FFFFFF;
    }
    .wpj{
      background-color: #d1e43c;color: #FFFFFF;
    }
    .el-dialog{
        border-radius: 10px;
    }
    .el-main{
        background-color: white;
        padding: 0 20px !important;
        border: 1px solid #e3eaf6;
        margin-left: 10px;
        border-radius: 5px;
        margin-top: 10px;
    }
    .el-menu-vertical-demo{
        height: calc(100vh - 375px);min-height: 500px;overflow: auto;border: solid 1px #e6e6e6;border-top: none;
    }
    .page_content{
        height: calc(100vh - 40px);
    }

    //考生信息
    .stuInfo{
        border: 1px solid @primary_b;
        border-radius: 5px;
        height: 214px;
    }
    .el-aside{
        .dtk_all{
            border: 1px solid rgb(227 234 246);margin-top:10px;height: calc(100vh - 380px);overflow: auto;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }
        .dtk_all::-webkit-scrollbar {
            display: none;
        }
        .dtk_h{
            background-color: #f3f3f3;padding: 10px;margin: 0 10px;font-weight: 700;
            border-left: 3px solid #409EFF;
        }
        ul{
            margin: 0;
            padding: 0;
            margin-right:5px;
        }
        li{
            list-style-type: none;
            float: left;
            border: 1px solid #f3f3f3;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            margin-left: 3px;
            margin-bottom:3px;
            cursor: pointer;
        }
    }
    .all_subject{
        height: calc(100vh - 150px);overflow: auto;
        p{
            margin: 0;
            padding: 0;
        }
        ul li{
            list-style-type:none;
            line-height:30px;
            .el-radio__label,.el-checkbox__label{
                font-size: 18px;
            }

        }
    }
    .all_subject::-webkit-scrollbar {
        display: none;
    }
    .el-radio__input,.el-radio__label,.el-checkbox__input,.el-checkbox__label{
      float: left;
    }
    .el-radio__inner,.el-checkbox__inner{
      margin-top: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/exam/ViewAnswerSheetExam.vue